import {
  InitConfigRedux,
  RematchDispatch,
  RematchRootState,
  init,
} from '@rematch/core';
import loadingPlugin, { ExtraModelsFromLoading } from '@rematch/loading';
import persistPlugin, { getPersistor } from '@rematch/persist';
import logger from 'redux-logger';
import { createMigrate } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import migrations, { currentStoreVersion } from '@/migrations';
import { RootModel, models } from '@/models';

const redux: InitConfigRedux = {
  middlewares: [...(process.env.NODE_ENV === 'development' ? [logger] : [])],
};

const store = init<RootModel, ExtraModelsFromLoading<RootModel>>({
  models,
  plugins: [
    loadingPlugin(),
    persistPlugin({
      key: `persist-storage-bps`,
      storage,
      version: currentStoreVersion,
      whitelist: ['teams', 'options', 'viewGuides', 'filters'],
      migrate: createMigrate(migrations),
    }),
  ],
  redux,
});

const persistor = getPersistor();

export default store;
export { persistor };
export type Store = typeof store;
export type Dispatch = RematchDispatch<RootModel>;
export type RootState = RematchRootState<
  RootModel,
  ExtraModelsFromLoading<RootModel>
>;
